import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as TransactionDetailsAction from "../actionTypes/transactionActionTypes";
import * as TransactionActionCreators from "../actionCreators/transactionDetailsActionCreators"
import { getTransactionDetails, submitTransactionConsent, getTaxContent, getUpdateContent } from "../services/APIservice";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";


function* onGetTransactionDetails() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(TransactionActionCreators.getTransactionDetailsRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getTransactionDetails);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(TransactionActionCreators.getTransactionDetailsSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(TransactionActionCreators.getTransactionDetailsFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(TransactionActionCreators.getTransactionDetailsFailure(error))
    }
  }
}

function* onSubmitTransactionConsent({ request }: TransactionDetailsAction.SubmitTransactionConsentAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(TransactionActionCreators.submitTransactionConsentRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(submitTransactionConsent, request);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(TransactionActionCreators.submitTransactionConsentSuccess(data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(TransactionActionCreators.submitTransactionConsentFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(TransactionActionCreators.submitTransactionConsentFailure(error))
    }
  }
}

function* onGetTaxContent() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(TransactionActionCreators.getTaxRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getTaxContent);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(TransactionActionCreators.getTaxSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(TransactionActionCreators.getTaxFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(TransactionActionCreators.getTaxFailure(error))
    }
  }
}




function* onGetUploadContent() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(TransactionActionCreators.getTaxRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getUpdateContent);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(TransactionActionCreators.getUpdateSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(TransactionActionCreators.getTaxFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(TransactionActionCreators.getTaxFailure(error))
    }
  }
}






function* watchOnGetTransactionDetails() {
  yield takeEvery(TransactionDetailsAction.GET_TRANSACTION_DETAILS, onGetTransactionDetails)
}

function* watchOnSubmitTransactionConsent() {
  yield takeEvery(TransactionDetailsAction.SUBMIT_TRANSACTION_CONSENT, onSubmitTransactionConsent)
}

function* watchOnGetTaxContent() {
  yield takeEvery(TransactionDetailsAction.GET_TAX_DETAILS, onGetTaxContent)
}

function* watchOnGetUploadContent() {
  yield takeEvery(TransactionDetailsAction.GET_UPLOAD_DETAILS, onGetUploadContent)
}

export default function* TransactionSaga() {
  yield all([
    fork(watchOnGetTransactionDetails),
    fork(watchOnSubmitTransactionConsent),
    fork(watchOnGetTaxContent),
    fork(watchOnGetUploadContent)
  ])
}